import * as IoC from 'typescript-ioc';
import { JobRunner } from '../job-runner';
import { EventExecutionParams, IJobExecutionRunner, JobDtoType } from '../index';
import { JobsDAO } from '../../../api/implementations/jobs.dao';
import { JobTrackingService } from './job-tracking.service';

export class JobExecutionRunner extends JobRunner implements IJobExecutionRunner {
    public static create(jobResult: JobDtoType): JobExecutionRunner {
        return new JobExecutionRunner(jobResult.jobId, jobResult.jobType, jobResult);
    }

    private constructor(
        id,
        type,
        jobResult,
        private readonly jobTrackingService: JobTrackingService = IoC.Container.get(JobTrackingService)
    ) {
        super(id, type, jobResult);
    }

    public isFinished(): boolean {
        return this.isCompleted() || this.isFailed();
    }

    public get name() {
        return super.name;
    }
    public get description() {
        return super.description;
    }

    public inExecutionContext(contextParams: EventExecutionParams) {
        return !!(
            this.getDetails()?.['accountId'] === contextParams.accountId &&
            this.getDetails()?.['eventId'] === contextParams.eventId
        );
    }

    public dismiss = async (): Promise<void> => {
        if (this.inProgress()) return;
        this.jobTrackingService.trackJobExecutionResult(this);
        return await IoC.Container.get(JobsDAO).markJobAsReviewed(this.id);
    };
}
